import fetch from 'cross-fetch';
import { ApiV1Base, ApiPrefix, json, statusCheck, getCookie } from '../util/icwUtility';

export const REPORT_UPLOAD_INIT = 'REPORT_UPLOAD_INIT';
export function actReportUploadInit() {
  return { type: REPORT_UPLOAD_INIT };
}

export const REPORT_UPLOAD_EDIT = 'REPORT_UPLOAD_EDIT';
export function actReportUploadEdit() {
  return { type: REPORT_UPLOAD_EDIT };
}

// Confrim Account Before Upload File

export const CONFIRM_ACCOUNT_BEGIN = 'CONFIRM_ACCOUNT_BEGIN';
function actConfirmAccountBegin() {
  return { type: CONFIRM_ACCOUNT_BEGIN };
}

export const CONFIRM_ACCOUNT_SUCCESS = 'CONFIRM_ACCOUNT_SUCCESS';
export function actConfirmAccountSuccess(result) {
  return { type: CONFIRM_ACCOUNT_SUCCESS, result };
}

export const CONFIRM_ACCOUNT_FAIL = 'CONFIRM_ACCOUNT_FAIL';
export function actConfirmAccountFail(reason) {
  return { type: CONFIRM_ACCOUNT_FAIL, reason };
}

export function actConfirmAccount() {
  return (dispatch, getState) => {
    dispatch(actConfirmAccountBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/auth/confirm/account`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...getState().reportUploadWorkspace.data,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((json) => {
        if (json) {
          dispatch(actConfirmAccountSuccess(json));
        } else {
          dispatch(actConfirmAccountFail(json.error ? 'User exist' : ''));
        }
      })
      .catch((err) => {
        dispatch(actConfirmAccountFail(err));
      });
  };
}

// Create Document Record

export const REPORT_CREATE_RECORD_BEGIN = 'REPORT_CREATE_RECORD_BEGIN';
function actReportCreateRecordBegin() {
  return { type: REPORT_CREATE_RECORD_BEGIN };
}

export const REPORT_CREATE_RECORD_SUCCESS = 'REPORT_CREATE_RECORD_SUCCESS';
export function actReportCreateRecordSuccess() {
  return { type: REPORT_CREATE_RECORD_SUCCESS };
}

export const REPORT_CREATE_RECORD_FAIL = 'REPORT_CREATE_RECORD_FAIL';
export function actReportCreateRecordFail(reason) {
  return { type: REPORT_CREATE_RECORD_FAIL, reason };
}

export function actReportCreateRecord(fileArr) {
  return (dispatch, getState) => {
    dispatch(actReportCreateRecordBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/files/create/document/record`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        files: fileArr,
        type: getState().reportUploadWorkspace.data.reportType,
        userId: getState().reportUploadWorkspace.data.user.id,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((json) => {
        if (json) {
          dispatch(actReportCreateRecordSuccess());
        } else {
          dispatch(actReportCreateRecordFail(json.error ? 'User exist' : ''));
        }
      })
      .catch((err) => {
        dispatch(actReportCreateRecordFail(err));
      });
  };
}

// Create Email Record

export const CREATE_EMAIL_RECORD_BEGIN = 'CREATE_EMAIL_RECORD_BEGIN';
function actCreateEmailRecordBegin() {
  return { type: CREATE_EMAIL_RECORD_BEGIN };
}

export const CREATE_EMAIL_RECORD_SUCCESS = 'CREATE_EMAIL_RECORD_SUCCESS';
export function actCreateEmailRecordSuccess() {
  return { type: CREATE_EMAIL_RECORD_SUCCESS };
}

export const CREATE_EMAIL_RECORD_FAIL = 'CREATE_EMAIL_RECORD_FAIL';
export function actCreateEmailRecordFail(reason) {
  return { type: CREATE_EMAIL_RECORD_FAIL, reason };
}

export function actCreateEmailRecord(fileContent) {
  return (dispatch, getState) => {
    dispatch(actCreateEmailRecordBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/files/create/email/record`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        files: fileContent,
        type: getState().reportUploadWorkspace.data.type,
        user: getState().reportUploadWorkspace.data.user,
        company: getState().reportUploadWorkspace.data.company,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((json) => {
        if (json) {
          dispatch(actCreateEmailRecordSuccess());
        } else {
          dispatch(actCreateEmailRecordFail(json.error ? 'User exist' : ''));
        }
      })
      .catch((err) => {
        dispatch(actCreateEmailRecordFail(err));
      });
  };
}
